import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ManageSubscriptionComponent} from './manage-subscription/manage-subscription.component';
import {HeaderComponent} from './header/header.component';
import {MessageCenterComponent} from './message-center/message-center.component';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalModule} from 'ngx-bootstrap/modal';
import {JwtParserService} from '../../shared/services/jwt-parser.service';
import {AuthGuard} from '../../shared/services/auth.guard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from '../../shared/services/interceptor/api.interceptor';
import {ModalService} from '../../shared/services/modal.service';
import {ManageSubscriptionsRoutingModule} from './manage-subscriptions-routing.module';
import {SharedModule} from '../../shared/shared.module';
import {TooltipModalComponent} from '../../shared/components/tooltip-modal/tooltip-modal.component';
import {CurrentPlanComponent} from './current-plan/current-plan.component';
import {CurrentPaymentComponent} from './current-payment/current-payment.component';
import {CustomerServiceComponent} from './customer-service/customer-service.component';


@NgModule({
    declarations: [
        ManageSubscriptionComponent,
        HeaderComponent,
        MessageCenterComponent,
        CurrentPlanComponent,
        CurrentPaymentComponent,
        CustomerServiceComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ManageSubscriptionsRoutingModule,
        ModalModule.forRoot(),
        SharedModule
    ],
    exports: [
        ManageSubscriptionComponent,
        HeaderComponent,
        MessageCenterComponent
    ],
    providers: [JwtParserService, AuthGuard, TooltipModalComponent, {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
        ModalService],
    schemas: [NO_ERRORS_SCHEMA]
})
export class ManageSubscriptionsModule {
}
